import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

export interface ApiConfigState {
  account_id?: string ;
}

const initialState: ApiConfigState = {
  account_id: Cookies.get(`last_account_id`),
};

const apiConfigSlice = createSlice({
  name: "apiConfig",
  initialState,
  reducers: {
    setAccountId(state, action: { payload: string }) {
      state.account_id = action.payload;

      sessionStorage.setItem("account_id", action.payload);
    },
  },
});

export const { setAccountId } = apiConfigSlice.actions;
export default apiConfigSlice.reducer;
